import { createStore, combineReducers } from 'redux';
import { appGlobalReducer } from "state-management/reducers";

const rootReducer = combineReducers({
    appGlobal: appGlobalReducer,
});

export const store = createStore(rootReducer);








